/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanFrameActionPlusIcon32Regular = forwardRef('ScanFrameActionPlusIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M24 3a5 5 0 0 1 5 5v3a1 1 0 1 1-2 0V8a3 3 0 0 0-3-3h-3a1 1 0 1 1 0-2h3Z" }),
        React.createElement("path", { d: "M3 24a5 5 0 0 0 5 5h3a1 1 0 1 0 0-2H8a3 3 0 0 1-3-3v-3a1 1 0 1 0-2 0v3Z" }),
        React.createElement("path", { d: "M29 24a5 5 0 0 1-5 5h-3a1 1 0 1 1 0-2h3a3 3 0 0 0 3-3v-3a1 1 0 1 1 2 0v3Z" }),
        React.createElement("path", { d: "M3 8a5 5 0 0 1 5-5h3a1 1 0 1 1 0 2H8a3 3 0 0 0-3 3v3a1 1 0 1 1-2 0V8Z" }),
        React.createElement("path", { d: "M17 10a1 1 0 1 0-2 0v5h-5a1 1 0 1 0 0 2h5v5a1 1 0 1 0 2 0v-5h5a1 1 0 1 0 0-2h-5v-5Z" })));
});
